module.exports = __webpack_public_path__ + "static/img/bg-tr.6d7a98ce.png";